/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HumanityBatchTrxBlockListRequest } from '../models/HumanityBatchTrxBlockListRequest';
import type { HumanityBatchTrxDetailInfo } from '../models/HumanityBatchTrxDetailInfo';
import type { HumanityBatchTrxDetailRequest } from '../models/HumanityBatchTrxDetailRequest';
import type { HumanityBatchTrxListInfo } from '../models/HumanityBatchTrxListInfo';
import type { HumanityBatchTrxListRequest } from '../models/HumanityBatchTrxListRequest';
import type { HumanityBatchTrxSummaryInfo } from '../models/HumanityBatchTrxSummaryInfo';
import type { HumanityBatchTrxSummaryRequest } from '../models/HumanityBatchTrxSummaryRequest';
import type { HumanityBatchTrxTransactionListRequest } from '../models/HumanityBatchTrxTransactionListRequest';
import type { HumanityBlockListInfo } from '../models/HumanityBlockListInfo';
import type { HumanityTrxListInfo } from '../models/HumanityTrxListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BatchControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBatchTrxDetail({
        requestBody,
    }: {
        requestBody: HumanityBatchTrxDetailRequest,
    }): CancelablePromise<HumanityBatchTrxDetailInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/batch',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBatchTrxTransactionList({
        requestBody,
    }: {
        requestBody: HumanityBatchTrxTransactionListRequest,
    }): CancelablePromise<HumanityTrxListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/batch/transaction/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBatchSummary({
        requestBody,
    }: {
        requestBody: HumanityBatchTrxSummaryRequest,
    }): CancelablePromise<Array<HumanityBatchTrxSummaryInfo>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/batch/summary',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBatchTrxList({
        requestBody,
    }: {
        requestBody: HumanityBatchTrxListRequest,
    }): CancelablePromise<HumanityBatchTrxListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/batch/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getBatchTrxBlockList({
        requestBody,
    }: {
        requestBody: HumanityBatchTrxBlockListRequest,
    }): CancelablePromise<HumanityBlockListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/batch/block/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
